import { debouncer, documentReady } from "../utility/utils";

export const playVideo = (wrappingElement) => {
  const hasVideo = wrappingElement.querySelector('video, iframe');
  if (!hasVideo) {
    console.warn('No video or iframe found in the provided element.');
    return;
  }

  // if the video is an iframe
  if(!!wrappingElement.querySelector('iframe')){
    const iframe = wrappingElement.querySelector('iframe');
    const src = iframe.getAttribute('src');
    const playSrc = src + '&autoplay=true';
    iframe.setAttribute('src', playSrc);
  } else {
    const video = wrappingElement.querySelector('video');
    video.play();
  }
}

export const resetVideo = (wrappingElement) => {
  const hasVideo = wrappingElement.querySelector('video, iframe');
  if (!hasVideo) {
    console.warn('No video or iframe found in the provided element.');
    return;
  }

  // if the video is an iframe
  if(!!wrappingElement.querySelector('iframe')){
    const iframe = wrappingElement.querySelector('iframe');
    const src = iframe.getAttribute('src');
    const resetSrc = src.replace('&autoplay=true', '');
    iframe.setAttribute('src', resetSrc);
  } else {
    const video = wrappingElement.querySelector('video');
    video.pause();
    video.currentTime = 0;
  }
}

export const initializeVideo = (event) => {
  // Play videos on play button
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.video_block__trigger') || !!e.target.closest('a.video_block__trigger')) {
      e.preventDefault();
      const target = e.target.closest('.video_block, .media_block');
      const trigger = target.querySelector('a.video_block__trigger');

      if(trigger.getAttribute('data-modal-target')){
        return;
      }


      // Fade out trigger
      trigger.classList.add('fadeOut');
      setTimeout(function(){
        trigger.classList.add('hide');
      }, 300);      

      playVideo(target);
    }
  });

  // Add class to vertical aspect ratio videos for better styling
  const videos = document.querySelectorAll('video');
  videos.forEach(video => {
    const aspectRatio = video.videoWidth / video.videoHeight;
    if (aspectRatio < 1) {
      video.classList.add('vertical');
    }
  });
};
